// src/utils/auth.js
import { jwtDecode } from 'jwt-decode';

export const isLoggedIn = () => {
  const token = localStorage.getItem('token');
  if (token) {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp > currentTime) {
      return true;
    }
  }
  return false;
};

export const getUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};